import React, { useState } from "react";
import { useQuery } from "@tanstack/react-query";
import { useApi } from "@/lib/api";
import { PageHeader, Panel, StatusBadge, PageLoader, EmptyState, TextInput } from "@/lib/ui";
import { ScrollText } from "lucide-react";

export default function Audit() {
  const api = useApi();
  const [filter, setFilter] = useState("");
  const { data: logs = [], isLoading } = useQuery({
    queryKey: ["audit", filter],
    queryFn: () => api.get(`/audit${filter ? `?action=${encodeURIComponent(filter)}` : ""}`),
  });

  return (
    <div>
      <PageHeader kicker="System" title="Audit Log">
        <TextInput placeholder="Filter by action…" value={filter} onChange={(e) => setFilter(e.target.value)} className="w-56" data-testid="audit-filter" />
      </PageHeader>
      {isLoading ? <PageLoader /> : logs.length === 0 ? (
        <EmptyState icon={ScrollText} title="No audit records" hint="Every login, change, approval, upload and AI action is recorded here with who / what / when / old & new values." />
      ) : (
        <Panel className="overflow-x-auto">
          <table className="w-full text-sm">
            <thead>
              <tr className="text-left text-[10px] uppercase tracking-wider text-muted-foreground border-b border-border">
                <th className="p-3 font-medium">When</th>
                <th className="p-3 font-medium">Actor</th>
                <th className="p-3 font-medium">Action</th>
                <th className="p-3 font-medium">Entity</th>
                <th className="p-3 font-medium">Change</th>
              </tr>
            </thead>
            <tbody className="font-mono text-xs">
              {logs.map((l) => (
                <tr key={l.id} className="border-b border-border/50 hover:bg-accent/30" data-testid={`audit-row-${l.id}`}>
                  <td className="p-3 text-muted-foreground whitespace-nowrap">{new Date(l.at || l.created_at).toLocaleString()}</td>
                  <td className="p-3">{l.actor_email}<span className="text-muted-foreground"> · {l.actor_role}</span></td>
                  <td className="p-3 text-primary">{l.action}</td>
                  <td className="p-3">{l.entity_type}{l.entity_id ? ` · ${String(l.entity_id).slice(0, 8)}` : ""}</td>
                  <td className="p-3 text-muted-foreground max-w-[240px] truncate">{l.new_value ? JSON.stringify(l.new_value) : "—"}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </Panel>
      )}
    </div>
  );
}
